<script setup>
import { BUTTON_SIZES } from '@/utils/components-configurations/app-button'

import AppButton from '@/components/ui/AppButton/AppButton'

defineOptions({
  name: 'AddProgressButton'
})

defineProps({
  active: {
    type: Boolean
  },

  disabled: {
    type: Boolean
  },

  iconName: {
    type: String,
    default: 'add-value'
  }
})

const emit = defineEmits({
  click: null
})

const onClick = () => emit('click')
</script>

<template>
  <AppButton
    :id="$attrs.id"
    :class="{
      'apb-Button-active': active,
      [$attrs.class]: Boolean($attrs.class)
    }"
    :disable="disabled"
    :icon="iconName"
    :size="BUTTON_SIZES.XS"
    class="apb-Button"
    height="16"
    type="tertiary-next"
    width="16"
    @click="onClick"
  />
</template>

<style lang="scss" scoped>
@import '~@/assets/styles/mixins';

.apb-Button {
  border-radius: 50%;

  &:not(&-active) {
    background: $grey-3-next;
    @include hoverState($grey-3-next, 1%);
    @include activeState($grey-3-next, 5%);
  }

  .ept-Cell-has-value &,
  .ept-Cell-has-threshold & {
    display: none;
  }

  &-active {
    background: $dark-2;
    color: $white;
    @include hoverState($dark-2, 1%);
    @include activeState($dark-2, 5%);
    display: flex;

    .ept-Cell-has-value &,
    .ept-Cell-has-threshold & {
      display: flex;
    }
  }
}
</style>
